export const CLASSESS =
  'ml-4 rounded-lg text-base border border-solid border-primary bg-white px-4 py-2 grow disabled:bg-gray-200 disabled:border-0'

export const CSS_MASKED =
  'absolute left-0 top-0 -z-10 inline-block h-0 border-0 focus-visible:ring-0 focus-visible:outline-none text-base'

export const STYLE = { fontFamily: 'var(--font-roboto-condensed)' }
